export function NotRendered(_props) {
  throw new Error('Failed assertion: should not be rendered');
}